import { useMemo, useState, useEffect } from 'preact/hooks';

const useProductWithVideo = (currentProduct, withPoster = false) => {
  const [poster, setPoster] = useState(null);
  const id = currentProduct.video?.value?.replace(/^\D+/g, '').split('/')[0];

  const media = useMemo(() => {
    if (!currentProduct.video?.value?.includes('vimeo')) {
      return currentProduct.media;
    }
    const position =
      currentProduct.videoPosition?.value > 0
        ? currentProduct.videoPosition.value - 1
        : 1;
    const video = {
      host: 'VIMEO',
      mediaContentType: 'EXTERNAL_VIDEO',
      originUrl: `https://player.vimeo.com/video/${id}`,
      previewImage: {
        id,
        ...(!!poster && poster),
      },
    };
    return [
      ...currentProduct.media.slice(0, position),
      video,
      ...currentProduct.media.slice(position),
    ];
  }, [currentProduct, poster]);

  const saveToCache = (key, value) => {
    if (!window.videoCache) {
      window.videoCache = [];
    }
    window.videoCache.push([key, value]);
    localStorage.setItem(
      'vimeoCache',
      JSON.stringify(window.videoCache.slice(-20)),
    );
  };

  const getCache = () => {
    if (!window.videoCache) {
      const savedCache = localStorage.getItem('vimeoCache');
      if (savedCache) {
        window.videoCache = JSON.parse(localStorage.getItem('vimeoCache'));
      } else {
        window.videoCache = [];
      }
    }
    return Object.fromEntries(window.videoCache);
  };

  useEffect(() => {
    if (withPoster && currentProduct.video?.value?.includes('vimeo')) {
      const cache = getCache();
      if (cache[id]) {
        setPoster({
          ...cache[id],
        });
      } else {
        fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`)
          .then((res) => res.json())
          .then((response) => {
            if (response.thumbnail_url) {
              setPoster({
                src: response.thumbnail_url,
                width: response.width,
                height: response.height,
              });
              saveToCache(id, {
                src: response.thumbnail_url,
                width: response.width,
                height: response.height,
              });
            }
          });
      }
    } else {
      setPoster(null);
    }
  }, [currentProduct]);

  if (!currentProduct.video?.value) {
    return currentProduct;
  }

  if (!currentProduct.video.value.includes('vimeo')) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/product-video.js: Unsupported video',
      currentProduct.video.value,
    );
    return currentProduct;
  }

  return {
    ...currentProduct,
    media,
  };
};

export default useProductWithVideo;
